import React from 'react';
import styled from 'styled-components';
import { DataGrid, IDataGridProps } from 'ui-toolkit/components';
import { StandardDocumentVersionDataWithZDocLoadingData } from './generateStandardDocumentsTableColumns';

export const StyledDocumentsTable: React.FC<IDataGridProps<StandardDocumentVersionDataWithZDocLoadingData>> = styled(
  DataGrid
)<IDataGridProps<StandardDocumentVersionDataWithZDocLoadingData>>`
  td {
    border: 1px solid ${(props) => props.theme.colors.lightGray} !important;
    * {
      white-space: pre-line;
      line-height: 1.3;
    }
  }
  //this is the filename column
  td:nth-child(3) {
    word-break: break-all;
  }

  thead tr th {
    border: 1px solid ${(props) => props.theme.colors.lightGray} !important;
    border-bottom: 3px solid ${(props) => props.theme.colors.lightGray} !important;
  }
`;
